import { useState } from 'react';

import { UnavailabilityPage } from './UnavailabilityPage';
import { UnsupportedMarketPage } from './UnsupportedMarketPage';

export const UnsupportedMarketRoute = () => {
  const [showForm, setShowForm] = useState(false);

  if (showForm) {
    return <UnavailabilityPage onClose={() => setShowForm(false)} />;
  }

  return <UnsupportedMarketPage onNotifyMe={() => setShowForm(true)} />;
};
